// @core/api/endpoints/landing/publish_landing_page.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LandingPageResponse,
  PublishLandingPageRequest,
} from '../../../types/landing';

const BASE_PATH = '/landing';

/**
 * Publish landing page
 * Publishes a draft page, making it accessible via its slug URL.
 */
export async function PublishLandingPage(
  page_id: string,
  data: PublishLandingPageRequest,
  options?: RequestOptions
): Promise<LandingPageResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/landing/pages/:page_id/publish`;
  requestPath = requestPath.replace(':page_id', encodeURIComponent(page_id));
  const requestOptions = options;
  return client.post<LandingPageResponse>(requestPath, data, requestOptions);
}
